import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconTrigger(props: IconProps) {
  return (
    <BaseIcon dataTestid={props.dataTestid || 'trigger'} {...props}>
      <path
        d="M8 4v8h1.77c.68 0 1.23.56 1.23 1.25V18l4.452-7h-1.773c-.945 0-1.537-1.037-1.069-1.87L15.497 4H8Zm-2-.75C6 2.56 6.55 2 7.23 2h9.538c.944 0 1.537 1.037 1.068 1.87L14.951 9h1.806c.957 0 1.547 1.061 1.054 1.894l-6.573 10.498C10.595 22.478 9 22.01 9 20.742V14H7.23C6.55 14 6 13.44 6 12.75v-9.5Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
